import { useEffect, useState } from "react";
import LabelInput from "../../../Component/labelInput";
import PageTitle from "../../../module/pageTitle";
import { InputField, Submitbtn } from "../../../Component";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import TextEditor from "../../../Component/textEditor";
import {
  containsNumber,
  containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpace,
  emailCheck,
  hasWhiteSpace,
  length_Ten,
  startsWithSpace,
  validateIsFileImageType,
  validateNameWithoutSpace,
  validateValueWithoutSpace,
} from "../../../Utils/validators";
import {
  containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpaceErrMsg,
  validateIsFileImageTypeErrMsg,
  validateIsNumberOnlyErrMsg,
  validUniqueName,
} from "../../../Utils/errorMsg";
import { createAuthor, uploadAutorImage } from "../adminSlice";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import { showSnackbar, hideSnackbar } from "../../../store/slices/snackbarSlice";

const CreateAuthor = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [name, setName] = useState<any>("");
  const [designation, setDesignation] = useState<any>("");
  const [about, setAbout] = useState<any>("");
  const [image, setImage] = useState<any>("");
  const [phoneNo, setPhoneNo] = useState<any>("");
  const [email, setEmail] = useState<any>("");
  const [linkedinURL, setLinkedinURL] = useState<any>("");
  const [facebookURL, setFacebookURL] = useState<any>("");
  const [instagramURL, setInstagramURL] = useState<any>("");
  const [googleURL, setGoogleURL] = useState<any>("");
  const [youtubeURL, setYoutubeURL] = useState<any>("");
  const [location, setLocation] = useState<any>("");
  const [uniqueName, setUniqueName] = useState<any>("");
  const [uniqueLink, setUniqueLink] = useState<any>("");
  const [imageUpload, setImageUpload] = useState<any>("");
  const socialRegex = {
    emailPattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    youtube: /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(@[a-zA-Z0-9._-]+|channel\/UC[a-zA-Z0-9_-]{22}|c\/[a-zA-Z0-9._-]+)|youtu\.be\/[a-zA-Z0-9_-]+)\/?$/,
    google: /^[a-zA-Z0-9._%+-]+@gmail\.com$/,
    instagram: /instagram\.com\/([a-zA-Z0-9._]+)/,
    linkedin: /(?:https?:\/\/)?(?:www\.)?linkedin\.com\/in\/([a-zA-Z0-9-]{3,100})/,
    facebook: /(?:https?:\/\/)?(?:www\.)?facebook\.com\/([a-zA-Z0-9.]{5,50})/,
  };
  useEffect(() => { }, []);
  const onchangeName = (value: any) => {
    setName(value);
  };
  const onchangeDesignation = (value: any) => {
    setDesignation(value);
  };
  const onchangeAbout = (value: any) => {
    setAbout(value);
  };
  const handleChaangeImg = (value: any) => {
    const mediaTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg'];

    const reader = new FileReader();
    const file = value.target.files[0];
    if (!mediaTypes.includes(file.type)) {
      console.error("Unsupported file type:", file.type);
      return;
    }
    reader.onloadend = () => {
      setImage(reader.result);
      setImageUpload(file);
    };
    reader.readAsDataURL(file);

  };
  const onchangePhoneNo = (value: any) => {
    const validNumber = /^[6-9]\d{0,9}$/;
    if (value !== "") {
      if (!validNumber.test(value)) {
        dispatch(showSnackbar({ message: "Author Create Successfully", type: "error" }));
        setTimeout(() => {
          hideSnackbar();
        }, 5000);
        return;
      } else if (!containsNumber(value)) {
        return;
      } else if (!validateValueWithoutSpace(value)) {
        return;
      } else {
        setPhoneNo(value);
      }
    } else {
      setPhoneNo(value);
    }
  };
  const onchangeEmail = (value: any) => {
    if (!startsWithSpace(value) && !hasWhiteSpace(value)) {
      setEmail(value);
    } else {
      return;
    }
  };
  function allemail(inputtxt: any) {
    if (email.match(emailCheck)) {
      return true;
    } else {
      return false;
    }
  }
  const onchangeLinkedinURL = (value: any) => {
    setLinkedinURL(value);
  };
  const onchangeFacebookURL = (value: any) => {
    setFacebookURL(value);
  };
  const onchangeInstagramURL = (value: any) => {
    setInstagramURL(value);
  };
  const onchangeGoogleURL = (value: any) => {
    setGoogleURL(value);
  };
  const onchangeYoutubeURL = (value: any) => {
    setYoutubeURL(value);
  };
  const onchangeLocation = (value: any) => {
    setLocation(value);
  };
  const onchangeUniqueName = (value: any) => {
    if (containsStartsWithSpecialCharsOrStartsWithNumberOrWhiteSpace(value)) {
      return;
    } else if (!validateNameWithoutSpace(value)) {
      return;
    }
    setUniqueName(value);
  };
  const onchangeUniqueLink = (value: any) => {
    setUniqueLink(value);
  };

  const onSubmitAutor = (imgData: any) => {
    const postData = {
      name: name,
      designation: designation,
      about: about,
      image: imgData,
      phoneNo: phoneNo,
      email: email,
      linkedIn: linkedinURL,
      facebook: facebookURL,
      instagram: instagramURL,
      google: googleURL,
      youtube: youtubeURL,
      location: location,
      uniqueName: uniqueName,
    };
    if (
      postData["linkedIn"] === null ||
      postData["linkedIn"] === undefined ||
      postData["linkedIn"] === ""
    ) {
      delete postData["linkedIn"];
    }
    if (
      postData["facebook"] === null ||
      postData["facebook"] === undefined ||
      postData["facebook"] === ""
    ) {
      delete postData["facebook"];
    }
    if (
      postData["instagram"] === null ||
      postData["instagram"] === undefined ||
      postData["instagram"] === ""
    ) {
      delete postData["instagram"];
    }
    if (
      postData["google"] === null ||
      postData["google"] === undefined ||
      postData["google"] === ""
    ) {
      delete postData["google"];
    }
    if (
      postData["youtube"] === null ||
      postData["youtube"] === undefined ||
      postData["youtube"] === ""
    ) {
      delete postData["youtube"];
    }
    if (
      postData["location"] === null ||
      postData["location"] === undefined ||
      postData["location"] === ""
    ) {
      delete postData["location"];
    }
    dispatch(
      createAuthor({
        params: postData,
        callback: (res: any) => {
          if (res?.status === "success") {
            setUniqueLink(res?.data?.AuthorLink);
            setName("");
            setDesignation("");
            setAbout("");
            setImage("");
            setPhoneNo("");
            setEmail("");
            setLinkedinURL("");
            setFacebookURL("");
            setInstagramURL("");
            setGoogleURL("");
            setYoutubeURL("");
            setLocation("");
            setUniqueName("");
            dispatch(showSnackbar({ message: "Author Create Successfully", type: res?.status }));
            setTimeout(() => {
              hideSnackbar();
            }, 5000);
          }
        },
        errorCallback: (error: any) => {
          dispatch(showSnackbar({ message: error?.data?.msg, type: error?.data?.type }));
          setTimeout(() => {
            hideSnackbar();
          }, 5000);
        },
      })
    );
  };
  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (validations()) {
      return;
    }
    if (!socialRegex?.emailPattern.test(email)) {
      dispatch(showSnackbar({ message: 'Invalid Email Address', type: 'error' }));
      setTimeout(() => {
        dispatch(hideSnackbar());
      }, 5000);
      return;
    }
    if (linkedinURL !== "") {
      if (!socialRegex?.linkedin.test(linkedinURL)) {
        dispatch(showSnackbar({ message: 'Invalid LinkedIn Id', type: 'error' }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
        return;
      }
    }
    if (facebookURL !== "") {
      if (!socialRegex?.facebook.test(facebookURL)) {
        dispatch(showSnackbar({ message: 'Invalid FaceBook Id', type: 'error' }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
        return;
      }
    }
    if (instagramURL !== "") {
      if (!socialRegex?.instagram.test(instagramURL)) {
        dispatch(showSnackbar({ message: 'Invalid Instagram Id', type: 'error' }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
        return;
      }
    }
    if (googleURL !== "") {
      if (!socialRegex?.google.test(googleURL)) {
        dispatch(showSnackbar({ message: 'Invalid Google Id', type: 'error' }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
        return;
      }
    }
    if (youtubeURL !== "") {
      if (!socialRegex?.youtube.test(youtubeURL)) {
        dispatch(showSnackbar({ message: 'Invalid YoutubeId', type: 'error' }));
        setTimeout(() => {
          dispatch(hideSnackbar());
        }, 5000);
        return;
      }
    }
    if (imageUpload) {
      dispatch(
        uploadAutorImage({
          params: imageUpload,
          callback: (res: any) => {
            if (res?.status === "success") {
              onSubmitAutor(res?.data?.name);
            }
          },
          errorCallback: (error: any) => { },
        })
      );
    }
  };
  const validations = () => {
    let valid = false;
    if (name === "" || designation === "" || about === "" || phoneNo === "" || email === "" || image === "" || uniqueName === "") {
      valid = true;
    }
    return valid;
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle name={"Create Author"} />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4 ">
          <form onSubmit={handleSubmit}>
            <div className="row ">
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Name"} isRequired />
                <InputField
                  placeholder={"Enter Name"}
                  setInputText={(value: any) => onchangeName(value)}
                  value={name}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Designation"} isRequired />
                <InputField
                  placeholder={"Enter Designation"}
                  setInputText={(value: any) => onchangeDesignation(value)}
                  value={designation}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Phone No."} isRequired />
                <InputField
                  placeholder={"Enter Phone No."}
                  setInputText={(value: any) => onchangePhoneNo(value)}
                  value={phoneNo}
                  maxLength={length_Ten}
                  minLength={length_Ten}
                />
              </div>

              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Email"} isRequired />
                <InputField
                  placeholder={"Enter Email"}
                  setInputText={(value: any) => onchangeEmail(value)}
                  value={email}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Linkedin URL"} />
                <InputField
                  placeholder={"Enter Linkedin URL"}
                  setInputText={(value: any) => onchangeLinkedinURL(value)}
                  value={linkedinURL}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Facebook URL"} />
                <InputField
                  placeholder={"Enter Facebook URL"}
                  setInputText={(value: any) => onchangeFacebookURL(value)}
                  value={facebookURL}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Instagram URL"} />
                <InputField
                  placeholder={"Enter Instagram URL"}
                  setInputText={(value: any) => onchangeInstagramURL(value)}
                  value={instagramURL}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Google URL"} />
                <InputField
                  placeholder={"Enter Google URL"}
                  setInputText={(value: any) => onchangeGoogleURL(value)}
                  value={googleURL}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Youtube URL"} />
                <InputField
                  placeholder={"Enter Youtube URL"}
                  setInputText={(value: any) => onchangeYoutubeURL(value)}
                  value={youtubeURL}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Location"} />
                <InputField
                  placeholder={"Enter Location"}
                  setInputText={(value: any) => onchangeLocation(value)}
                  value={location}
                />
              </div>
              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Unique Name"} isRequired />
                <InputField
                  placeholder={"Enter Unique Name"}
                  setInputText={(value: any) => onchangeUniqueName(value)}
                  value={uniqueName}
                />
              </div>

              <div className="col-md-4 mb-3">
                <LabelInput labelName={"Image"} isRequired />
                <ImagePickerAndViewer
                  value={image}
                  handleChange={(value: any) => handleChaangeImg(value)}
                  htmlFor={`backImage-upload-author`}
                  doctype={""}
                />
              </div>
              <div className="col-md-12 mb-3">
                <LabelInput labelName={"About"} />
                <TextEditor
                  onChange={(value: any) => onchangeAbout(value)}
                  value={about}
                />
              </div>
            </div>
            <div className="col-md-3 mx-auto">
              <Submitbtn name={"Submit"} disabled={validations()} />
            </div>

            <div className="col-md-4 mb-3">
              <LabelInput labelName={"Unique Link"} />
              <InputField
                placeholder={"Enter Unique Link"}
                setInputText={(value: any) => onchangeUniqueLink(value)}
                value={uniqueLink}
                disabled
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateAuthor;
